export const days = ["Sun", "Mon", "Tue", "wed", "Thu", "Fri", "Sat"];
export const daysFromSunday = ["Sun", "Mon", "Tue", "wed", "Thu", "Fri", "Sat"];

export const times = [
  {
    normalTime: "07:00AM",
    militaryTime: 7,
  },
  {
    normalTime: "08:00AM",
    militaryTime: 8,
  },
  {
    normalTime: "09:00AM",
    militaryTime: 9,
  },
  {
    normalTime: "10:00AM",
    militaryTime: 10,
  },
  {
    normalTime: "11:00AM",
    militaryTime: 11,
  },
  {
    normalTime: "12:00AM",
    militaryTime: 12,
  },
  {
    normalTime: "01:00PM",
    militaryTime: 13,
  },
  {
    normalTime: "02:00PM",
    militaryTime: 14,
  },
  {
    normalTime: "03:00PM",
    militaryTime: 15,
  },
  {
    normalTime: "04:00PM",
    militaryTime: 16,
  },
  {
    normalTime: "05:00PM",
    militaryTime: 17,
  },
  {
    normalTime: "06:00PM",
    militaryTime: 18,
  },
  {
    normalTime: "07:00PM",
    militaryTime: 19,
  },
  {
    normalTime: "08:00PM",
    militaryTime: 20,
  },
  {
    normalTime: "09:00PM",
    militaryTime: 21,
  },
  {
    normalTime: "10:00PM",
    militaryTime: 22,
  },
  {
    normalTime: "11:00PM",
    militaryTime: 23,
  },
  {
    normalTime: "12:00PM",
    militaryTime: 24,
  },
  {
    normalTime: "12:00AM",
    militaryTime: 0,
  },
  {
    normalTime: "01:00AM",
    militaryTime: 1,
  },
  {
    normalTime: "02:00AM",
    militaryTime: 2,
  },
  {
    normalTime: "03:00AM",
    militaryTime: 3,
  },
  {
    normalTime: "04:00AM",
    militaryTime: 4,
  },
  {
    normalTime: "05:00AM",
    militaryTime: 5,
  },
  {
    normalTime: "06:00AM",
    militaryTime: 6,
  },
];
export const timeWithInterval = [
  {
    normalTime: "07:00AM",
    militaryTime: 7,
  },
  {
    normalTime: "07:30AM",
    militaryTime: 7.3,
  },
  {
    normalTime: "08:00AM",
    militaryTime: 8,
  },
  {
    normalTime: "08:30AM",
    militaryTime: 8.3,
  },
  {
    normalTime: "09:00AM",
    militaryTime: 9,
  },
  {
    normalTime: "09:30AM",
    militaryTime: 9.3,
  },
  {
    normalTime: "10:00AM",
    militaryTime: 10,
  },
  {
    normalTime: "10:30AM",
    militaryTime: 10.3,
  },
  {
    normalTime: "11:00AM",
    militaryTime: 11,
  },
  {
    normalTime: "11:30AM",
    militaryTime: 11.3,
  },
  {
    normalTime: "12:00AM",
    militaryTime: 12,
  },
  {
    normalTime: "12:30AM",
    militaryTime: 12.3,
  },
  {
    normalTime: "01:00PM",
    militaryTime: 13,
  },
  {
    normalTime: "01:30PM",
    militaryTime: 13.3,
  },
  {
    normalTime: "02:00PM",
    militaryTime: 14,
  },
  {
    normalTime: "02:30PM",
    militaryTime: 14.3,
  },
  {
    normalTime: "03:00PM",
    militaryTime: 15,
  },
  {
    normalTime: "03:30PM",
    militaryTime: 15.3,
  },
  {
    normalTime: "04:00PM",
    militaryTime: 16,
  },
  {
    normalTime: "04:30PM",
    militaryTime: 16.3,
  },
  {
    normalTime: "05:00PM",
    militaryTime: 17,
  },
  {
    normalTime: "05:30PM",
    militaryTime: 17.3,
  },
  {
    normalTime: "06:00PM",
    militaryTime: 18,
  },
  {
    normalTime: "06:30PM",
    militaryTime: 18.3,
  },
  {
    normalTime: "07:00PM",
    militaryTime: 19,
  },
  {
    normalTime: "07:30PM",
    militaryTime: 19.3,
  },
  {
    normalTime: "08:00PM",
    militaryTime: 20,
  },
  {
    normalTime: "08:30PM",
    militaryTime: 20.3,
  },
  {
    normalTime: "09:00PM",
    militaryTime: 21,
  },
  {
    normalTime: "09:30PM",
    militaryTime: 21.3,
  },
  {
    normalTime: "10:00PM",
    militaryTime: 22,
  },
  {
    normalTime: "10:30PM",
    militaryTime: 22.3,
  },
  {
    normalTime: "11:00PM",
    militaryTime: 23,
  },
  {
    normalTime: "11:30PM",
    militaryTime: 23.3,
  },
  {
    normalTime: "12:00PM",
    militaryTime: 24,
  },

  {
    normalTime: "12:00AM",
    militaryTime: 0,
  },
  {
    normalTime: "12:30AM",
    militaryTime: 0.3,
  },
  {
    normalTime: "01:00AM",
    militaryTime: 1,
  },
  {
    normalTime: "01:30AM",
    militaryTime: 1.3,
  },
  {
    normalTime: "02:00AM",
    militaryTime: 2,
  },
  {
    normalTime: "02:30AM",
    militaryTime: 2.3,
  },
  {
    normalTime: "03:00AM",
    militaryTime: 3,
  },
  {
    normalTime: "03:30AM",
    militaryTime: 3.3,
  },
  {
    normalTime: "04:00AM",
    militaryTime: 4,
  },
  {
    normalTime: "04:30AM",
    militaryTime: 4.3,
  },
  {
    normalTime: "05:00AM",
    militaryTime: 5,
  },
  {
    normalTime: "05:30AM",
    militaryTime: 5.3,
  },
  {
    normalTime: "06:00AM",
    militaryTime: 6,
  },
  {
    normalTime: "06:30AM",
    militaryTime: 6.3,
  },
];

export const months = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];
export const borderTopColors = ["#FFCC4D", "#FF7F37", "#020011", "#6956E5"];
export const cellHeight = 140;
export const cellWidth = 150;
